import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from 'shared/components/buttons/Button/Button';
import { Box, FlexBoxColumnAlign } from 'styles/layout';

const CenteredContainer = styled(FlexBoxColumnAlign)`
  padding: 3rem 10rem;
  text-align: center;
`;

const StyledButton = styled(Button)`
  margin-right: 2rem;
`;

const ConsultIntegrationUnmatch = ({ onUnlink, onCancel }) => (
  <CenteredContainer>
    <h3>
      Are you sure you want to un-reconcile this consult with this associated
      ADT Order?
    </h3>
    <h3>
      The associated Patient will enter the Orphaned ADT Orders list and will be
      available to reconcile with another Consult.
    </h3>
    <h3>
      The consult will need to be reconciled with the correct ADT Order before
      it is closed.
    </h3>
    <Box mt="1rem">
      <StyledButton
        onClick={onUnlink}
        color="secondary"
        variant="contained"
      >
        Confirm
      </StyledButton>
      <Button onClick={onCancel} color="secondary" variant="outlined">
        Cancel
      </Button>
    </Box>
  </CenteredContainer>
);

ConsultIntegrationUnmatch.propTypes = {
  onUnlink: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConsultIntegrationUnmatch;
